import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import StringToColor from 'string-to-color'
  import StarRating from '@/components/common/StarRating.vue'
  import type { PropType } from 'vue'
  import type { Testimonial as TestimonialState } from '@/services/interfaces/Course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Testimonial',
  props: {
    testimonial: {
      required: true,
      type: Object as PropType<TestimonialState>,
    },
  },
  setup(__props) {

const props = __props;

  

  const initial = computed(() => {
    const splitNames = props.testimonial?.name.split(' ') || []
    let initial = splitNames.length ? splitNames[0][0] : ''
    if (initial && splitNames[1]) {
      initial += splitNames[1][0]
    }
    return initial
  })

  const initialColor = computed(() => StringToColor(props.testimonial.name))

return { __sfc: true,props, initial, initialColor, computed, StringToColor, StarRating }
}

})